/*
 * @创建文件时间: 2019-11-07 10:39:43
 * @最后修改人: lfq
 * @最后修改时间: 2020-05-03 17:37:34
 * @联系Qq:1638245306
 * @文件介绍:  维修专项工程
 */

export default [
    {
        path: 'wxzxReportMaintainPlan',
        name: 'wxzxReportMaintainPlan',
        meta: {
            title: '维修计划上报',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxReportMaintainPlan')
    }, {
        path: 'wxzxMaintainProDesign',
        name: 'wxzxMaintainProDesign',
        meta: {
            title: '维修工程设计',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxMaintainProDesign')
    },
    {
        path: 'wxzxDesignChangeTable',
        name: 'wxzxDesignChangeTable',
        meta: {
            title: '维修设计变更',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxDesignChangeTable')
    },
    {
        path: 'wxzxMonthPay',
        name: 'wxzxMonthPay',
        meta: {
            title: '维修工作计量月报',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxMonthPay')
    },
    {
        path: 'wxzxQualityJobUnitTable',
        name: 'wxzxQualityJobUnitTable',
        meta: {
            title: '质量责任卡承包单位',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxQualityJobUnitTable')
    },
    {
        path: 'wxzxListingPaymentTable',
        name: 'wxzxListingPaymentTable',
        meta: {
            title: '清单期中支付',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxListingPaymentTable')
    },
    {
        path: 'wxzxProQsAfterEvaluateTable',
        name: 'wxzxProQsAfterEvaluateTable',
        meta: {
            title: '工程质量后评价',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxProQsAfterEvaluateTable')
    },
    {
        path: 'wxzxAcceptApplyTable',
        name: 'wxzxAcceptApplyTable',
        meta: {
            title: '交工验收申请',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxAcceptApplyTable') 
    },
    {
        path: 'wxzxAcceptApply',
        name: 'wxzxAcceptApply',
        meta: {
            title: '交工验收申请',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxAcceptApply')
    },
    {
        path: 'wxzxAcceptanceMaterials',
        name: 'wxzxAcceptanceMaterials',
        meta: {
            title: '维修工程交工验收材料',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/acceptanceManagement/wxzxAcceptanceMaterials') 
    },
    {
        path: 'overallMerit',
        name: 'overallMerit',
        meta: {
            title: '工程综合评价管理',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/overallMerits/overallMerit')
    },
    {
        path: 'wxzxProApplyCertificatTable',
        name: 'wxzxProApplyCertificatTable',
        meta: {
            title: '维修工程交工验收证书',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxProApplyCertificatTable')
    },
    {
        path: 'wxzxDelyworkAcceptConTable',
        name: 'wxzxDelyworkAcceptConTable',
        meta: {
            title: '维修工程交工验收报告',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxDelyworkAcceptConTable')
    },
    {
        path: 'wxzxQualityScoreTable',
        name: 'wxzxQualityScoreTable',
        meta: {
            title: '交工验收工程质量评分',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxQualityScoreTable')
    },
    {
        path: 'wxzxImEvaluateTable',
        name: 'wxzxImEvaluateTable',
        meta: {
            title: '管理综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxImEvaluateTable')
    },
    {
        path: 'wxzxDesignWorkCeTable',
        name: 'wxzxDesignWorkCeTable',
        meta: {
            title: '设计工作综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxDesignWorkCeTable')
    },
    {
        path: 'wxzxSuperviseCeTable',
        name: 'wxzxSuperviseCeTable',
        meta: {
            title: '监理工作综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxSuperviseCeTable')
    },
    {
        path: 'wxzxCmceTable',
        name: 'wxzxCmceTable',
        meta: {
            title: '施工管理综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxCmceTable')
    },
    {
        path: 'wxzxCompletedQgTable',
        name: 'wxzxCompletedQgTable',
        meta: {
            title: '竣工验收委员会工程质量评分表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxCompletedQgTable')
    },
    {
        path: 'wxzxCaCertificateTable',
        name: 'wxzxCaCertificateTable',
        meta: {
            title: '维修工程竣工验收鉴定书',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxCaCertificateTable')
    },
    {
        path: 'wxzxCompletedQeTable',
        name: 'wxzxCompletedQeTable',
        meta: {
            title: '竣工验收工程质量评价表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxCompletedQeTable')
    },
    {
        path: 'wxzxComplatedCeTable',
        name: 'wxzxComplatedCeTable',
        meta: {
            title: '竣工验收项目综合评定表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/specialMaintenance/wxzxComplatedCeTable')
    }
]